import { AllocationMethodType } from '../types';

export const ALLOCATION_METHODS: {
  key: AllocationMethodType;
  label: string;
  description: string;
  badgeColor: string;
}[] = [
  {
    key: 'fixed_lot',
    label: 'Fixed Lot',
    description:
      'Assigns a fixed lot size to every sub-account regardless of balance or equity.',
    badgeColor:
      'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400',
  },
  {
    key: 'balance_ratio',
    label: 'Balance Ratio',
    description:
      'Distributes trades proportionally based on each sub-account balance relative to total pool balance.',
    badgeColor:
      'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400',
  },
  {
    key: 'equity_ratio',
    label: 'Equity Ratio',
    description:
      'Allocates trade volume in proportion to sub-account equity, adjusting for open position P&L.',
    badgeColor:
      'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400',
  },
  {
    key: 'percentage',
    label: 'Percentage Allocation',
    description:
      'Allocates a fixed percentage of total master trade volume to each client sub-account.',
    badgeColor:
      'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400',
  },
  {
    key: 'multiplier',
    label: 'Multiplier',
    description:
      'Scales the master volume by a custom multiplier factor defined individually per client.',
    badgeColor:
      'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-400',
  },
  {
    key: 'risk_based',
    label: 'Risk-Based',
    description:
      'Dynamically calculates volume based on sub-account risk limits and stop-loss distance.',
    badgeColor:
      'bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-400',
  },
];

export const LEVERAGE_OPTIONS = ['1:50', '1:100', '1:200', '1:400', '1:500'];

export const TRADING_SYMBOLS = [
  'EURUSD',
  'GBPUSD',
  'USDJPY',
  'AUDUSD',
  'USDCAD',
  'XAUUSD',
  'BTCUSD',
  'US30',
];

export const DEFAULT_RISK_METRICS = {
  maxDrawdownLimit: 25,
  dailyLossLimit: 5000,
  maxLeverage: '1:500',
  emergencyStopActive: false,
  activeMarginCallCount: 0,
  symbolRestrictions: [],
  maxOpenLotsPerAccount: 50,
  stopOutLevel: 30,
};
